<template>
    <div class="container mx-auto p-4">
      <div class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ubicación</th>
                    <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Activo</th>
                    <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="recinto in recintos" :key="recinto.id_recinto">
                    <td class="px-6 py-4 whitespace-nowrap">{{ recinto.nombre }}</td>
                    <td class="px-6 py-4 whitespace-nowrap">{{ recinto.ubicacion }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-center">
                      <label class="switch-container">
                        <input type="checkbox"
                               :checked="recinto.activo == 1"
                               @change="toggleActivo(recinto)" />
                        <span class="slider"></span>
                      </label>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-center">
                      <button @click="editRecinto(recinto)" class="text-blue-600 hover:text-blue-900 mr-2">Editar</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <button @click="showCreateModal = true" class="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
        Agregar Recinto
      </button>
      <RecintoModal
        v-if="showCreateModal"
        @close="showCreateModal = false"
        @saved="fetchRecintos"
      />
      <RecintoModal
        v-if="recintoToEdit"
        :recinto="recintoToEdit"
        @close="recintoToEdit = null"
        @saved="handleEditSaved"
      />
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import { useToast } from "vue-toastification";
  import RecintoModal from '@/components/modals/recintos/RecintoModal.vue';
  
  const recintos = ref([]);
  const showCreateModal = ref(false);
  const recintoToEdit = ref(null);
  const toast = useToast();
  
  function fetchRecintos() {
    fetch('/api/recintos')
      .then(res => res.json())
      .then(data => recintos.value = data)
      .catch(() => toast.error("Error al cargar los recintos"));
  }
  
  function toggleActivo(recinto) {
    fetch(`/api/recintos/toggle/${recinto.id_recinto}`, { method: 'POST' })
      .then(res => res.json())
      .then(data => {
        recinto.activo = data.activo;
        toast.success(data.activo ? "Recinto activado" : "Recinto desactivado");
      })
      .catch(() => toast.error("Error al cambiar el estado del recinto"));
  }
  
  function editRecinto(recinto) {
    recintoToEdit.value = { ...recinto };
  }
  function handleEditSaved() {
    recintoToEdit.value = null;
    fetchRecintos();
  }
  
  onMounted(fetchRecintos);
  </script>
  
  <style lang="sass" scoped>
  .switch-container
    display: inline-block
    width: 46px
    height: 26px
    position: relative
  
    input
      opacity: 0
      width: 0
      height: 0
  
    .slider
      position: absolute
      cursor: pointer
      top: 0
      left: 0
      right: 0
      bottom: 0
      background-color: #ccc
      transition: .4s
      border-radius: 26px
  
    input:checked + .slider
      background-color: #22c55e
  
    .slider:before
      position: absolute
      content: ""
      height: 22px
      width: 22px
      left: 2px
      bottom: 2px
      background-color: white
      transition: .4s
      border-radius: 50%
  
    input:checked + .slider:before
      transform: translateX(20px)
  </style>
  